import React from "react";
import { Facebook, ArrowRight } from "lucide-react";

// TikTok inline SVG icon (lucide doesn't ship one)
const TikTokIcon = ({ size = 22, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.45a8.16 8.16 0 0 0 4.77 1.52V6.53a4.85 4.85 0 0 1-1.84-.16z" />
  </svg>
);

const SocialSection = () => {
  return (
    <section id="social" className="bg-[color:var(--hc-cream-2)]" data-testid="social-section">
      <div className="container-hc py-20 md:py-28">
        <div className="max-w-3xl">
          <div className="text-xs font-bold tracking-[0.25em] text-[color:var(--hc-coral)]">
            FOLLOW ALONG
          </div>
          <h2 className="font-serif-display mt-5 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[color:var(--hc-navy)]">
            See daily life at <span className="italic text-[color:var(--hc-coral)]">Hillcrest.</span>
          </h2>
          <p className="mt-6 text-lg text-[color:var(--hc-navy)]/75 leading-relaxed">
            Birthdays, sing-alongs, holiday meals, and the small moments that make Hillcrest
            home — shared every week on Facebook and TikTok. Follow us, leave a comment, send
            a heart to a loved one.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {/* Facebook */}
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noreferrer"
            className="group relative overflow-hidden rounded-[28px] bg-[#1877F2] text-white p-8 md:p-10 shadow-xl transition-transform hover:-translate-y-1"
            data-testid="social-facebook-card"
          >
            <div className="flex items-center justify-between">
              <div className="w-14 h-14 rounded-2xl bg-white/15 flex items-center justify-center backdrop-blur-sm">
                <Facebook size={26} className="text-white" />
              </div>
              <div className="text-[11px] font-bold tracking-[0.22em] text-white/80">
                @HILLCRESTAL
              </div>
            </div>
            <h3 className="font-serif-display mt-8 text-3xl md:text-4xl leading-tight">
              Facebook
            </h3>
            <p className="mt-3 text-white/85 leading-relaxed max-w-md">
              Photo updates, event recaps, monthly menus, and posts from the family. The best
              way to stay connected day-to-day.
            </p>
            <div className="mt-7 inline-flex items-center gap-2 font-semibold text-white group-hover:gap-3 transition-all">
              Visit Our Page <ArrowRight size={18} />
            </div>
            <div className="absolute -right-10 -bottom-10 w-44 h-44 rounded-full bg-white/10 blur-2xl pointer-events-none" />
          </a>

          {/* TikTok */}
          <a
            href="https://tiktok.com"
            target="_blank"
            rel="noreferrer"
            className="group relative overflow-hidden rounded-[28px] bg-[#0f0e2f] text-white p-8 md:p-10 shadow-xl transition-transform hover:-translate-y-1"
            data-testid="social-tiktok-card"
          >
            <div className="flex items-center justify-between">
              <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center backdrop-blur-sm relative">
                <TikTokIcon size={24} className="text-white" />
                {/* TikTok signature color glow */}
                <span className="absolute -inset-0.5 rounded-2xl bg-gradient-to-br from-[#FE2C55]/40 to-[#25F4EE]/40 blur-md -z-10" />
              </div>
              <div className="text-[11px] font-bold tracking-[0.22em] text-white/70">
                @HILLCRESTAL
              </div>
            </div>
            <h3 className="font-serif-display mt-8 text-3xl md:text-4xl leading-tight">
              <span className="bg-gradient-to-r from-[#25F4EE] via-white to-[#FE2C55] bg-clip-text text-transparent">
                TikTok
              </span>
            </h3>
            <p className="mt-3 text-white/80 leading-relaxed max-w-md">
              Short clips from inside the home — bingo wins, dance routines, resident shout-outs,
              and the occasional staff prank.
            </p>
            <div className="mt-7 inline-flex items-center gap-2 font-semibold text-white group-hover:gap-3 transition-all">
              Watch on TikTok <ArrowRight size={18} />
            </div>
            <div className="absolute -right-10 -bottom-10 w-44 h-44 rounded-full bg-[#FE2C55]/25 blur-2xl pointer-events-none" />
            <div className="absolute -left-12 -top-12 w-40 h-40 rounded-full bg-[#25F4EE]/20 blur-2xl pointer-events-none" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default SocialSection;
